import React from 'react';
import { Button, Typography } from 'antd';
import { CheckCircleOutlined, ReloadOutlined } from '@ant-design/icons';
import { feedbackOptions } from '../utils/constants';

const { Text } = Typography;

export default function FeedbackButtons({ message, onFeedback }) {
  if (!message?.chat_log_id && !message?.request_id) return null;

  const status = message.feedback_status;
  const selectedType = message.feedback_type;

  // Once feedback has been recorded, drop the row of buttons and show a
  // single clean confirmation. Keeping the disabled buttons around alongside
  // a "Feedback recorded" tag looked cluttered and system-log-ish.
  if (status === 'submitted') {
    const selected = feedbackOptions.find((option) => option.value === selectedType);
    return (
      <div className="glp1-feedback">
        <div className="glp1-feedback-confirmation" role="status" aria-live="polite">
          <CheckCircleOutlined aria-hidden="true" />
          <Text type="secondary">
            {selected ? (
              <>
                Thanks for your feedback — recorded as <strong>{selected.label.toLowerCase()}</strong>.
              </>
            ) : (
              <>Thanks for your feedback.</>
            )}
          </Text>
        </div>
      </div>
    );
  }

  return (
    <div className="glp1-feedback">
      <div className="glp1-feedback-row">
        <Text type="secondary" style={{ fontSize: 12 }}>
          Was this useful?
        </Text>
        {feedbackOptions.map((option) => (
          <Button
            key={option.value}
            size="small"
            icon={option.icon}
            type={selectedType === option.value ? 'primary' : 'default'}
            loading={status === 'sending' && selectedType === option.value}
            disabled={status === 'sending'}
            onClick={() => onFeedback(message, option.value)}
          >
            {option.label}
          </Button>
        ))}
        {status === 'error' ? (
          <Button
            size="small"
            type="text"
            icon={<ReloadOutlined />}
            onClick={() => selectedType && onFeedback(message, selectedType)}
          >
            Couldn't save — try again
          </Button>
        ) : null}
      </div>
    </div>
  );
}
